const usePlainPaste = _ref => {
  let {
    elementRef,
    onChange
  } = _ref;

  const handlePaste = e => {
    // Prevent the default paste behavior
    e.preventDefault(); // Get plain text from clipboard

    const text = e.clipboardData.getData('text/plain'); // Insert text at cursor position

    const selection = window.getSelection();

    if (selection !== null && selection !== void 0 && selection.rangeCount) {
      var _elementRef$current;

      // Delete any selected text
      selection.deleteFromDocument(); // Insert the plain text

      const range = selection.getRangeAt(0);
      const textNode = document.createTextNode(text);
      range.insertNode(textNode); // Move cursor to the end of inserted text

      range.setStartAfter(textNode);
      range.setEndAfter(textNode);
      selection.removeAllRanges();
      selection.addRange(range); // Trigger content change

      const newContent = ((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.innerText) || '';
      onChange(newContent);
    }
  };

  return {
    handlePaste
  };
};

export default usePlainPaste;